// Auto-split from i18n.js — language: fa
export default {
    translation: {
        // routes & menus
        Dashboard: 'داشبورد',
        'Space Data': 'داده‌های فضا',
        'Equipment Data': 'داده‌های تجهیزات',
        'Meter Data': 'داده‌های کنتور',
        'Tenant Data': 'داده‌های مستأجر',
        'Store Data': 'داده‌های فروشگاه',
        'Shopfloor Data': 'داده‌های کارگاه',
        'Combined Equipment Data': 'داده‌های تجهیزات ترکیبی',
        'Auxiliary System': 'سیستم کمکی',
        Microgrid: 'ریزشبکه',
        'Energy Storage Power Station': 'نیروگاه',
        'Photovoltaic Power Station': 'نیروگاه',
        'Fault Alarm': 'هشدار خرابی',
        Monitoring: 'پایش تجهیزات',
        'Advanced Reporting': 'گزارش‌گیری پیشرفته',
        'Knowledge Base': 'پایگاه دانش',
        'Energy Category Data': 'تحلیل دسته‌بندی انرژی',
        'Energy Item Data': 'تحلیل آیتم انرژی',
        Carbon: 'تحلیل انتشار کربن',
        Cost: 'تحلیل هزینه',
        Output: 'تحلیل خروجی',
        Income: 'تحلیل درآمد',
        Efficiency: 'تحلیل کارایی',
        Load: 'تحلیل بار',
        Statistics: 'تحلیل آماری',
        'Batch Analysis': 'تحلیل انبوه',
        Saving: 'تحلیل صرفه‌جوییⒺ',
        Plan: 'تحلیل برنامهⒺ',
        Prediction: 'تحلیل پیش‌بینیⒺ',
        'Production': 'تولید',
        'Space Production': 'تحلیل انرژی مصرفی تولید',
        'Equipment Tracking': 'دفترچه تجهیزات',
        'Equipment Comparison': 'تحلیل مقایسه‌ای',
        'Shopfloor Comparison': 'تحلیل مقایسه‌ای',
        'Store Comparison': 'تحلیل مقایسه‌ای',
        'Space Comparison': 'تحلیل مقایسه‌ای',
        'Combined Equipment Comparison': 'تحلیل مقایسه‌ای',
        'Tenant Comparison': 'تحلیل مقایسه‌ای',
        'Environment Monitor': 'پایش محیط زیست',
        'Meter Energy': 'تحلیل انرژی کنتور',
        'Meter Prediction': 'تحلیل پیش‌بینی کنتورⒺ',
        'Virtual Meter Prediction': 'تحلیل پیش‌بینی کنتور مجازیⒺ',
        'Offline Meter Prediction': 'تحلیل پیش‌بینی کنتور آفلاینⒺ',
        'Meter Carbon': 'تحلیل کربن کنتور',
        'Meter Cost': 'تحلیل هزینه کنتور',
        'Meter Trend': 'تحلیل روند کنتور',
        'Meter Realtime': 'تحلیل بی‌درنگ کنتور',
        'Meter Saving': 'تحلیل صرفه‌جویی کنتورⒺ',
        'Meter Plan': 'تحلیل برنامه کنتورⒺ',
        'Master Meter Submeters Balance': 'تحلیل تعادل کنتور اصلی-فرعی',
        'Meter Batch Analysis': 'تحلیل انبوه کنتور',
        'Meter Comparison': 'تحلیل مقایسه‌ای کنتور',
        'Meter Tracking': 'دفترچه کنتور',
        'Virtual Meter Saving': 'تحلیل صرفه‌جویی کنتور مجازیⒺ',
        'Virtual Meter Plan': 'تحلیل برنامه کنتور مجازیⒺ',
        'Virtual Meter Energy': 'تحلیل انرژی کنتور مجازی',
        'Virtual Meter Carbon': 'تحلیل کربن کنتور مجازی',
        'Virtual Meter Cost': 'تحلیل هزینه کنتور مجازی',
        'Virtual Meter Batch Analysis': 'تحلیل انبوه کنتور مجازی',
        'Virtual Meter Comparison': 'تحلیل مقایسه‌ای کنتور مجازی',
        'Offline Meter Energy': 'تحلیل انرژی کنتور آفلاین',
        'Offline Meter Carbon': 'تحلیل کربن کنتور آفلاین',
        'Offline Meter Cost': 'تحلیل هزینه کنتور آفلاین',
        'Offline Meter Batch Analysis': 'تحلیل انبوه کنتور آفلاین',
        'Offline Meter Saving': 'تحلیل صرفه‌جویی کنتور آفلاینⒺ',
        'Offline Meter Plan': 'تحلیل برنامه کنتور آفلاینⒺ',
        'Offline Meter Input': 'ورود داده کنتور آفلاین',
        'Tenant Bill': 'صورتحساب مستأجر',
        'Energy Flow Diagram': 'نمودار جریان انرژی',
        'Distribution System': 'سیستم توزیع',
        'SVG System': 'سیستم بصری‌سازی پیکربندی',
        'Faults Data': 'تحلیل خرابی',
        'Space Equipments': 'تجهیزات فضایی',
        'Combined Equipments': 'تجهیزات ترکیبی',
        'Energy Storage Power Station List': 'لیست نیروگاه‌ها',
        'Energy Storage Power Station Details': 'پایش تجهیزات',
        'Energy Storage Power Station Reporting': 'گزارش داده',
        'Energy Storage Power Station Alarm': 'هشدار خرابی',
        'Energy Storage Power Station Maintenance': 'نگهداری و تعمیرات',
        'Enter Production': 'ورود تولید',
        'Multiple Microgrids': 'داده‌های چندایستگاه',
        'Multiple Microgrids Dashboard': 'نمای کلی چندایستگاه',
        'Multiple Microgrids List': 'لیست نیروگاه‌ها',
        'Single Microgrid': 'داده‌های تک‌ایستگاه',
        'Single Microgrid Dashboard': 'نمای کلی تک‌ایستگاه',
        'Single Microgrid Details': 'داده‌های تجهیزات',
        'Single Microgrid Fault Alarm': 'هشدار خرابی',
        'Microgrid Reports': 'گزارش‌های آماری',
        'Microgrid Reports Energy': 'گزارش انرژی الکتریکی',
        'Microgrid Reports Revenue': 'گزارش درآمد',
        'Microgrid Reports Parameters': 'پرس‌وجوی داده',
        'Multiple Energy Storage Power Stations': 'داده‌های چندایستگاه ذخیره‌ساز',
        'Multiple Energy Storage Power Stations Dashboard': 'نمای کلی چندایستگاه ذخیره‌ساز',
        'Multiple Energy Storage Power Stations List': 'لیست نیروگاه‌های ذخیره‌ساز',
        'Single Energy Storage Power Station': 'داده‌های تک‌ایستگاه ذخیره‌ساز',
        'Single Energy Storage Power Station Dashboard': 'نمای کلی تک‌ایستگاه ذخیره‌ساز',
        'Single Energy Storage Power Station Details': 'داده‌های تجهیزات ذخیره‌ساز',
        'Single Energy Storage Power Station Fault Alarm': 'هشدار خرابی ذخیره‌ساز',
        'Energy Storage Power Station Reports': 'گزارش‌های آماری ذخیره‌ساز',
        'Energy Storage Power Station Reports Energy': 'گزارش انرژی الکتریکی ذخیره‌ساز',
        'Energy Storage Power Station Reports Revenue': 'گزارش درآمد ذخیره‌ساز',
        'Energy Storage Power Station Reports Parameters': 'پرس‌وجوی داده ذخیره‌ساز',
        'Photovoltaic Power Station List': 'لیست نیروگاه‌ها',
        'Photovoltaic Power Station Details': 'پایش تجهیزات',
        'Photovoltaic Power Station Reporting': 'گزارش داده',
        'Photovoltaic Power Station Alarm': 'هشدار خرابی',
        'Photovoltaic Power Station Maintenance': 'نگهداری و تعمیرات',
        'Multiple Photovoltaic Power Stations': 'داده‌های چندایستگاه',
        'Multiple Photovoltaic Power Stations Dashboard': 'نمای کلی چندایستگاه',
        'Multiple Photovoltaic Power Stations List': 'لیست نیروگاه‌ها',
        'Single Photovoltaic Power Station': 'داده‌های تک‌ایستگاه',
        'Single Photovoltaic Power Station Dashboard': 'نمای کلی تک‌ایستگاه',
        'Single Photovoltaic Power Station Details': 'داده‌های تجهیزات',
        'Single Photovoltaic Power Station Fault Alarm': 'هشدار خرابی',
        'Photovoltaic Power Station Reports': 'گزارش‌های آماری',
        'Photovoltaic Power Station Reports Energy': 'گزارش انرژی الکتریکی',
        'Photovoltaic Power Station Reports Revenue': 'گزارش درآمد',
        'Photovoltaic Power Station Reports Parameters': 'پرس‌وجوی داده',
        'Work Order': 'مدیریت دستورکار',
        'Work Order Installation': 'رکورد نصب',
        'Work Order Repair': 'رکورد تعمیر',
        'Work Order Inspection': 'رکورد بازرسی',
        'Total Number of Work Orders': 'تعداد کل دستورکارها',
        'Number of New Work Orders': 'تعداد دستورکارهای جدید',
        'Number of Inprogress Work Orders': 'تعداد دستورکارهای در حال انجام',
        'Number of Done Work Orders': 'تعداد دستورکارهای تکمیل‌شده',
        'Fuel Indicator': 'مصرف سوخت',
        'Charge Energy Indicator': 'انرژی شارژ',
        'Discharge Energy Indicator': 'انرژی دشارژ',
        'Charge Cost Indicator': 'هزینه شارژ',
        'Discharge Revenue Indicator': 'درآمد دشارژ',
        'HVAC': 'تهویه مطبوع',
        'Fire Control': 'آتش‌نشانی',
        'Store Dashboard': 'داشبورد فروشگاه‌ها',
        'Comprehensive overview of store energy performance': 'نمای جامع عملکرد انرژی فروشگاه‌ها',
        'Total Stores': 'مجموع فروشگاه‌ها',
        'Total Area': 'مساحت کل',
        'Active Meters': 'کنتورهای فعال',
        'Active Alerts': 'هشدارهای فعال',
        'Total Energy Consumption': 'مجموع مصرف انرژی',
        'Carbon Emissions': 'انتشارات کربن',
        'Current Period': 'دوره فعلی',
        'Energy Consumption by Category': 'مصرف انرژی بر اساس دسته‌بندی',
        'Cost Distribution by Category': 'توزیع هزینه بر اساس دسته‌بندی',
        'Monthly Energy & Cost Trends': 'روندهای ماهانه انرژی و هزینه',
        'Top 5 Energy Consuming Stores': '۵ فروشگاه پرمصرف انرژی',
        'Energy Category Details': 'جزئیات دسته‌بندی انرژی',
        'Store Performance Overview': 'مرور کلی عملکرد فروشگاه‌ها',
        'YoY Change': 'تغییر سالانه',
        'Per m²': 'به ازای هر متر مربع',
        'Usage Intensity': 'شدت استفاده',
        'Dashboard data loaded successfully': 'داده‌های داشبورد با موفقیت بارگذاری شد',
        'Failed to load dashboard data': 'بارگذاری داده‌های داشبورد ناموفق بود',
        'Store Name': 'نام فروشگاه',
        'Store Area': 'مساحت فروشگاه',
        'Energy Consumption': 'مصرف انرژی',
        'Consumption': 'مصرف',
        'last period': 'دوره قبل',
        // Tenant Dashboard
        'Tenant Dashboard': 'داشبورد مستأجران',
        'Comprehensive overview of tenant energy performance': 'نمای کلی عملکرد انرژی مستأجران',
        'Total Tenants': 'تعداد کل مستأجران',
        'Tenant Performance Overview': 'نمای کلی عملکرد مستأجران',
        'Tenant Name': 'نام مستأجر',
        'Tenant Area': 'مساحت مستأجر',
        'Tenant Type': 'نوع مستأجر',
        // Dashboard
        'Welcome to QiXuan': 'به QiXuan خوش آمدید',
        'An Industry Leading Energy Management System': 'سیستم مدیریت انرژی پیشرو در صنعت',
        "This Year's Consumption CATEGORY VALUE UNIT": 'مصرف امسال {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'هزینه امسال {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'مصرف این ماه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": 'تولید این ماه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Costs CATEGORY VALUE UNIT": 'هزینه این ماه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': 'مصرف مدت مشابه سال قبل {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year': 'هزینه مدت مشابه سال قبل {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'CATEGORY Consumption UNIT': 'مصرف {{CATEGORY}} {{UNIT}}',
        'CATEGORY Costs UNIT': 'هزینه {{CATEGORY}} {{UNIT}}',
        // Entities
        Space: 'فضا',
        Equipment: 'تجهیزات',
        Meter: 'کنتور',
        'Offline Meter': 'کنتور آفلاین',
        'Virtual Meter': 'کنتور مجازی',
        // Shopfloor Dashboard
        'Total Shopfloors': 'تعداد کل کارگاه‌ها',
        'Shopfloor Performance Overview': 'نمای کلی عملکرد کارگاه‌ها',
        'Shopfloor Name': 'نام کارگاه',
        'Shopfloor Area': 'مساحت کارگاه',
        // Equipment Dashboard
        'Equipment Dashboard': 'داشبورد تجهیزات',
        'Total Equipments': 'تعداد کل تجهیزات',
        'Equipment Performance Overview': 'نمای کلی عملکرد تجهیزات',
        'Equipment Name': 'نام تجهیز',
        'Equipment Type': 'نوع تجهیز',
        'Total Energy': 'انرژی کل',
        'Total Sensors': 'تعداد کل حسگر‌ها',
        'Increment Rate': 'نرخ رشد',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'تعداد کل تجهیزات ترکیبی',
        'Combined Equipment Performance Overview': 'نمای کلی عملکرد تجهیزات ترکیبی',
        'Combined Equipment Name': 'نام تجهیز ترکیبی',
        'Associated Equipments': 'تجهیزات مرتبط',

        Tenant: 'مستأجر',
        Store: 'فروشگاه',
        Shopfloor: 'کارگاه',
        'Combined Equipment': 'تجهیزات ترکیبی',
        'Cost Center': 'مرکز هزینه',
        Name: 'نام',
        DisplayName: 'نام نمایشی',
        UserName: 'نام کاربری',
        Description: 'توضیحات',
        'Energy Category': 'دسته‌بندی انرژی',
        'Child Spaces': 'زیرفضاها',
        'Associated Equipment': 'تجهیزات مرتبط',
        //Energy Categories
        Electricity: 'برق',
        Water: 'آب لوله‌کشی',
        'Natural Gas': 'گاز طبیعی',
        // SidePanelModal
        Settings: 'تنظیمات',
        'Set your own customized style': 'سبک سفارشی خود را تنظیم کنید',
        'Color Scheme': 'طرح رنگ',
        'Choose the perfect color mode for your app': 'حالت رنگ ایده‌آل را برای برنامه خود انتخاب کنید',
        Light: 'روشن',
        Dark: 'تاریک',
        'RTL Mode': 'حالت RTL',
        'Switch your language direction': 'جهت زبان خود را تغییر دهید',
        'Fluid Layout': 'چیدمان سیال',
        'Toggle container layout system': 'سیستم چیدمان کانتینر را تغییر دهید',
        'Navigation Position': 'موقعیت نوار ناوبری',
        'Vertical': 'عمودی',
        'Top': 'بالا',
        'Combo': 'ترکیبی',
        'Transparent': 'شفاف',
        'Inverted': 'برعکس',
        'Card': 'کارت',
        'Vibrant': 'پررنگ',
        'Select a suitable navigation system for your web application': 'یک سیستم ناوبری مناسب برای برنامه وب خود انتخاب کنید',
        'Vertical Nav': 'ناوبری عمودی',
        'Top Nav': 'ناوبری بالایی',
        'Vertical Navbar Style': 'سبک نوار ناوبری عمودی',
        'Switch between styles for your vertical navbar': 'بین سبک‌های نوار ناوبری عمودی خود جابه‌جا شوید',
        Language: 'زبان',
        'Switch between languages': 'بین زبان‌ها جابه‌جا شوید',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'این سیستم را می‌پسندید؟',
        'Get QiXuan now': 'هم‌اکنون QiXuan را دریافت کنید',
        'PQ.About': 'این تحلیل شامل انحراف ولتاژ، عدم تعادل ولتاژ، انحراف فرکانس و عدم تعادل جریان است. انحراف ولتاژ بر اساس (U−Un)/Un×100% محاسبه می‌شود؛ انحراف فرکانس بر اساس |f−fn| محاسبه می‌شود؛ عدم تعادل سه فاز بر اساس max(|Xi−Xavg|)/Xavg×100% محاسبه می‌شود و نیاز به هم‌زمانی زمانی کانال‌های سه فاز دارد. نتایج بر اساس سری زمانی کنتور انتخاب‌شده در دوره گزارش است. در صورت فقدان کانال‌های سه فاز یا عدم تطابق زمان، شاخص عدم تعادل رد می‌شود. نوسانات لحظه‌ای یا نمونه‌های از دست رفته ممکن است بدترین مقدار را بزرگنمایی کنند؛ برای ارزیابی حالت پایدار، توصیه می‌شود به شاخص‌های آماری مانند نرخ انطباق و P95 مراجعه شود.',
        Purchase: 'خرید نسخه سازمانی',
        ContactInfo: 'اطلاعات تماس',
        ProductWebsite: 'وب سایت محصول',
        CompanyWebsite: 'وب سایت شرکت',
        SalesPhone: 'تلفن فروش',
        // Query Panels
        'Base Period Begins': 'شروع دوره پایه',
        'Base Period Ends': 'پایان دوره پایه',
        'Comparison Types': 'نوع مقایسه',
        'Year-Over-Year': 'نسبت به سال قبل',
        'Month-On-Month': 'نسبت به ماه قبل',
        'Free Comparison': 'مقایسه آزاد',
        'None Comparison': 'بدون مقایسه',
        'Reporting Period Begins': 'شروع دوره گزارش',
        'Reporting Period Ends': 'پایان دوره گزارش',
        '(Optional)': '(اختیاری)',
        'Period Types': 'مقیاس زمانی',
        Yearly: 'سالانه',
        Monthly: 'ماهانه',
        Weekly: 'هفتگی',
        Daily: 'روزانه',
        Hourly: 'ساعتی',
        Submit: 'ارسال',
        'Input Energy Category': 'دسته‌بندی انرژی مصرفی',
        'Output Energy Category': 'دسته‌بندی انرژی تولیدی',
        'Fraction Parameter': 'پارامتر کسری',
        Search: 'جستجو',
        //DateRangePicker
        sunday: 'یکشنبه',
        monday: 'دوشنبه',
        tuesday: 'سه‌شنبه',
        wednesday: 'چهارشنبه',
        thursday: 'پنجشنبه',
        friday: 'جمعه',
        saturday: 'شنبه',
        ok: 'تأیید',
        today: 'امروز',
        yesterday: 'دیروز',
        hours: 'ساعت',
        minutes: 'دقیقه',
        seconds: 'ثانیه',
        last7Days: 'هفت روز گذشته',
        tomorrow: 'فردا',
        dayAfterTomorrow: 'پس فردا',
        next7Days: '۷ روز آینده',
        'Select Date Range': 'انتخاب بازه زمانی',
        //Card Summaries and Line Charts
        'Base Period': 'دوره پایه',
        'Reporting Period': 'دوره گزارش',
        'Per Unit Area': 'ارزش به ازای واحد سطح',
        'Per Capita': 'ارزش سرانه',
        'Per Unit Production': 'ارزش به ازای واحد محصول',
        Baseline: 'مقدار پایه',
        Actual: 'مقدار واقعی',
        'Baseline Value - Actual Value': 'مقدار پایه - مقدار واقعی',
        'Average Load': 'میانگین بار',
        'Maximum Load': 'حداکثر بار',
        'Load Factor': 'ضریب بار',
        'Ratio of Average Load to Maximum Load': 'نسبت میانگین بار به حداکثر بار',
        'Carbon Dioxide Emissions by Energy Category': 'سهم انتشار دی‌اکسید کربن',
        'Costs by Energy Category': 'سهم هزینه',
        'Incomes by Energy Category': 'سهم درآمد',
        'Electricity Consumption by Time-Of-Use': 'مصرف برق به تفکیک زمان مصرف',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'انتشار دی‌اکسید کربن ناشی از برق به تفکیک زمان مصرف',
        'Electricity Cost by Time-Of-Use': 'هزینه برق به تفکیک زمان مصرف',
        'CATEGORY UNIT Consumption by Energy Items': 'سهم مصرف آیتم {{CATEGORY}} {{UNIT}}',
        'Ton of Standard Coal by Energy Category': 'سهم تن زغال سنگ استاندارد (TCE)',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'سهم تن انتشار دی‌اکسید کربن (TCO2E)',
        'Reporting Period Consumption CATEGORY UNIT': 'مصرف دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'پیش‌بینی دوره گزارش {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} مصرف دوره گزارش {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} مصرف دوره گزارش {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'تولید دوره گزارش {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'تولید دوره پایه {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'مصرف دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'پیش‌بینی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'مصرف دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'پیش‌بینی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'مصرف دوره گزارش {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': 'مصرف دوره گزارش {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'مصرف دوره پایه {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'سهم دسته‌بندی زیرفضا {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'سهم کل زیرفضا',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': 'انتشار دی‌اکسید کربن دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'انتشار دی‌اکسید کربن دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': 'انتشار دی‌اکسید کربن دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'هزینه دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'هزینه دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'هزینه دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'خروجی دوره گزارش {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} خروجی دوره گزارش {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} خروجی دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'خروجی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'خروجی دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'درآمد دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'درآمد دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'درآمد دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'کل درآمد دوره گزارش {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'کارایی تجمعی دوره گزارش {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} کارایی تجمعی دوره گزارش {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} کارایی جامع تجمعی دوره گزارش {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} کارایی جامع تجمعی دوره گزارش {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} کارایی جامع تجمعی دوره پایه {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'کارایی لحظه‌ای {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} کارایی لحظه‌ای {{UNIT}}',
        'Equipment Efficiency Indicator': 'شاخص بهره‌وری انرژی تجهیزات',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} کارایی جامع لحظه‌ای {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'کارایی تجمعی دوره گزارش {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT': 'کارایی تجمعی دوره گزارش {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'کارایی تجمعی دوره پایه {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': 'کارایی تجمعی دوره پایه {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'حداکثر بار دوره پایه {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'حداکثر بار دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'میانگین بار دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'ضریب بار دوره گزارش {{CATEGORY}}',
        'Base Period CATEGORY Average Load VALUE UNIT': 'میانگین بار دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'میانگین دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'حداکثر دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'حداقل دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'میانگین حسابی دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'میانه دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'انحراف معیار نمونه دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'واریانس نمونه دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': 'صرفه‌جویی دوره گزارش {{CATEGORY}} (پایه - واقعی) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': 'کاهش دوره گزارش {{CATEGORY}} (پایه - واقعی) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'صرفه‌جویی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'صرفه‌جویی دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT': 'مصرف کنتور اصلی دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': 'مصرف کنتور اصلی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT': 'مصرف کنتورهای فرعی دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': 'مصرف کنتورهای فرعی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'اختلاف دوره گزارش {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'درصد اختلاف دوره گزارش',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'اختلاف دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'مقادیر روند',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'لیست خرابی‌ها',
        'Reporting Period Number of Fault VALUE': 'تعداد خرابی دوره گزارش: {{VALUE}}',
        'All Faults': 'همه خرابی‌ها',
        'Space Faults': 'خرابی‌های فضا',
        'Number of All Faults': 'تعداد کل خرابی‌ها',
        'Number of Space Faults': 'تعداد خرابی‌های فضا',
        'Total Number of Faults': 'تعداد کل خرابی‌ها',
        'Number of New Faults': 'تعداد خرابی‌های جدید',
        'Number of Inprogress Faults': 'تعداد خرابی‌های در حال انجام',
        'Number of Done Faults': 'تعداد خرابی‌های تکمیل‌شده',
        //Data Panels
        'Ton of Standard Coal': 'تن زغال سنگ استاندارد',
        'Ton of Carbon Dioxide Emissions': 'تن انتشار دی‌اکسید کربن',
        'Carbon Emissions Per Unit Of Energy Consumption': 'انتشار کربن به ازای واحد مصرف انرژی',
        'Operating Characteristic Curve': 'منحنی عملکرد',
        Tariff: 'تعرفه',
        'Detailed Data': 'داده‌های تفصیلی',
        'Child Spaces Data': 'داده‌های زیرفضاها',
        'Associated Equipment Data': 'داده‌های تجهیزات مرتبط',
        'This Year': 'امسال',
        'The Same Period Last Year': 'مدت مشابه سال قبل',
        'This Month': 'این ماه',
        'This Day': 'امروز',
        Total: 'مجموع',
        'No data found': 'داده‌ای یافت نشد',
        Export: 'خروجی',
        'AI Analysis': 'تحلیل هوش مصنوعی',
        Datetime: 'تاریخ و زمان',
        'Time-Of-Use Type': 'نوع زمان مصرف',
        'Top-Peak': 'اوج بالا',
        'On-Peak': 'اوج',
        'Mid-Peak': 'میانه',
        'Off-Peak': 'کم‌بار',
        'Deep': 'عمیق',
        Percentage: 'درصد',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'روند نقطه مقدار انرژی در ساعت گذشته',
        Circuit: 'مدار',
        Point: 'نقطه داده',
        'Realtime Value': 'مقدار بی‌درنگ',
        //Meter Tracking
        'Meter List': 'لیست کنتورها',
        'Edit Meter': 'ویرایش',
        'Start Value': 'مقدار شروع',
        'End Value': 'مقدار پایان',
        'Difference Value': 'مقدار اختلاف',
        'Start Integrity Rate': 'نرخ یکپارچگی داده شروع (%)',
        'End Integrity Rate': 'نرخ یکپارچگی داده پایان (%)',
        'Full Integrity Rate': 'نرخ یکپارچگی کل داده (%)',
        'Start Integrity Rate Description': 'نرخ یکپارچگی داده‌های اولیه: نسبت دستگاه‌هایی که در طول دوره آماری، به موفقیت خواندن مصرف انرژی در لحظه شروع را از بین تمام دستگاه‌ها دریافت کرده‌اند',
        'End Integrity Rate Description': 'نرخ یکپارچگی داده‌های نهایی: نسبت دستگاه‌هایی که در طول دوره آماری، به موفقیت خواندن مصرف انرژی در لحظه پایان را از بین تمام دستگاه‌ها دریافت کرده‌اند',
        'Full Integrity Rate Description': 'نرخ یکپارچگی داده‌های کامل: نسبت دستگاه‌هایی که در طول دوره آماری، به موفقیت خواندن مصرف انرژی در لحظه شروع و پایان را از بین تمام دستگاه‌ها دریافت کرده‌اند',
        //Equipment Tracking
        'Equipment List': 'لیست تجهیزات',
        'Edit Equipment': 'ویرایش',
        //Profile Dropdown
        Feedback: 'بازخورد',
        'Account Settings': 'تنظیمات حساب',
        Logout: 'خروج',
        //Authentication
        'Log in': 'ورود',
        'Email address': 'آدرس ایمیل',
        'Phone Number': 'شماره تلفن',
        Password: 'رمز عبور',
        CaptchaCode: 'کد امنیتی',
        Refresh: 'بازخوانی',
        'Remember me': 'مرا به خاطر بسپار',
        'Logged in as ': 'ورود به عنوان ',
        'Forgot Password?': 'رمز عبور را فراموش کرده‌اید؟',
        'Forgot your password?': 'رمز عبور خود را فراموش کرده‌اید؟',
        "Enter your email and we'll send you a reset link": 'ایمیل خود را وارد کنید، ما یک لینک بازنشانی برای شما ارسال می‌کنیم',
        "Enter your email and we'll send you a registration link": 'ایمیل خود را وارد کنید، ما یک لینک ثبت‌نام برای شما ارسال می‌کنیم',
        'Reset Password': 'بازنشانی رمز عبور',
        'Thanks for using QiXuan!': 'از استفاده شما از QiXuan متشکریم!',
        'You are now successfully signed out': 'شما با موفقیت خارج شدید',
        'Return to Login': 'بازگشت به صفحه ورود',
        'Please check your email!': 'لطفاً ایمیل خود را بررسی کنید!',
        'An email has been sent to ': 'یک ایمیل به آدرس ',
        'Please click on the included link to reset your password': 'لطفاً برای بازنشانی رمز عبور خود روی لینک موجود کلیک کنید',
        'Please click on the included link to register your account': 'لطفاً برای ثبت‌نام حساب کاربری خود روی لینک موجود کلیک کنید',
        'An email with password reset link is sent to ': 'ایمیلی حاوی لینک بازنشانی رمز عبور به آدرس ',
        'Change Password': 'تغییر رمز عبور',
        'Old Password': 'رمز عبور قدیمی',
        'New Password': 'رمز عبور جدید',
        'Confirm Password': 'تکرار رمز عبور جدید',
        'Update Password': 'به‌روزرسانی رمز عبور',
        'Password has been changed!': 'رمز عبور تغییر یافت!',
        'Verification code has been sent to your inbox. \
        Please copy it to the input box below.':
            'کد تأیید به صندوق ورودی شما ارسال شد. لطفاً آن را در کادر ورودی زیر کپی کنید.',
        'New to QiXuan': 'کاربر جدید QiXuan هستید',
        'Create an account': 'ایجاد حساب کاربری',
        'EMAIL Account registration successful': 'ثبت‌نام حساب {{EMAIL}} موفقیت‌آمیز بود',
        'Thanks for verifying your account!': 'از تأیید حساب کاربری خود متشکریم!',
        'Your code is': 'کد شما',
        'Send verification code': 'ارسال کد تأیید',
        'Please wait for NUMBER seconds': 'لطفاً {{NUMBER}} ثانیه صبر کنید',
        'Password reset': 'بازنشانی رمز عبور',
        'Please wait for approval': 'لطفاً منتظر تأیید باشید',
        //notification
        Notifications: 'اعلان‌ها',
        'Mark all as read': 'علامت‌گذاری همه به عنوان خوانده‌شده',
        'View all': 'همه',
        'Notification New': 'جدید',
        'Notification Earlier': 'قدیمی‌تر',
        'Notification List': 'لیست اعلان‌ها',
        'Bulk actions': 'عملیات گروهی',
        'Notification Subject': 'موضوع',
        'Notification Created Datetime': 'زمان ایجاد',
        'Notification Message': 'محتوا',
        'Notification Priority': 'اولویت',
        'Notification Status': 'وضعیت',
        'Notification Mark As Read': 'علامت‌گذاری به عنوان خوانده‌شده',
        'Notification Mark As Acknowledged': 'تأیید',
        'Notification Low': 'پایین',
        'Notification Medium': 'متوسط',
        'Notification High': 'بالا',
        'Notification Critical': 'بحرانی',
        'Notification Unread': 'خوانده‌نشده',
        'Notification Read': 'خوانده‌شده',
        'Notification Acknowledged': 'تأیید شده',
        'Notification Archive': 'بایگانی',
        'Notification Delete': 'حذف',
        'Notification Apply': 'اعمال',
        'Notification Start Datetime': 'زمان شروع',
        'Notification End Datetime': 'زمان پایان',
        'Notification Update Datetime': 'زمان به‌روزرسانی',
        //Monitoring
        'Run Commands': 'اجرای دستورات',
        'Pin Code': 'رمز',
        'Unlock': 'باز کردن قفل',
        'Set Value': 'مقدار تنظیم شده',
        'Fault Alarms': 'هشدار خرابی',
        'Instantaneous Efficiency VALUE UNIT': 'کارایی لحظه‌ای {{VALUE}} {{UNIT}}',
        'Communication Status': 'وضعیت ارتباط',
        'Communication Online': 'آنلاین',
        'Communication Offline': 'آفلاین',
        'Equipment Status': 'وضعیت تجهیزات',
        'Equipment Running': 'در حال کار',
        'Equipment Stopped': 'متوقف',
        'Show Up to': 'تعداد نمایش در هر صفحه',
        All: 'همه',
        'FROM - TO of TOTAL': 'نمایش {{FROM}} تا {{TO}} از مجموع {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': 'انرژی',
        'Microgrid Revenue': 'درآمد',
        'Microgrid Carbon': 'انتشار کربن',
        'Photovoltaic Generation': 'تولید برق خورشیدی',
        'EV Charger Consumption': 'مصرف برق ایستگاه شارژ',
        'Load Consumption': 'مصرف برق بار',
        'Grid Buy': 'خرید برق از شبکه',
        'Grid Sell': 'فروش برق به شبکه',
        'EV Charger': 'ایستگاه شارژ',
        'Heat Pump': 'پمپ حرارتی',
        'Photovoltaic': 'خورشیدی',
        'PCS Run State': 'وضعیت عملکرد PCS',
        'PCS Unknown': 'ناشناخته',
        'PCS Initializing': 'روشن‌شدن اولیه',
        'PCS Standby': 'آماده‌به‌کار',
        'PCS Shutdown': 'خاموش',
        'PCS Fault': 'خرابی',
        'PCS Running': 'در حال کار',
        'Battery Power': 'توان باتری',
        'Photovoltaic Power': 'توان خورشیدی',
        'Grid Power': 'توان شبکه',
        'Load Power': 'توان بار',
        Reporting: 'گزارش داده',
        Maintenance: 'نگهداری و تعمیرات',
        'General Information': 'اطلاعات عمومی',
        'Serial Number': 'شماره سریال',
        Address: 'آدرس',
        'Postal Code': 'کد پستی',
        'Rated Capacity': 'ظرفیت اسمی',
        'Rated Power': 'توان اسمی',
        Latitude: 'عرض جغرافیایی',
        Longitude: 'طول جغرافیایی',
        'Strategy Management': 'مدیریت استراتژی',
        'Charging Schedule': 'برنامه زمانی شارژ',
        'Charge Start Time': 'زمان شروع شارژ',
        'Charge End Time': 'زمان پایان شارژ',
        'Discharge Start Time': 'زمان شروع دشارژ',
        'Discharge End Time': 'زمان پایان دشارژ',
        'Total Rated Power': 'مجموع توان اسمی',
        'Total Rated Capacity': 'مجموع ظرفیت اسمی',
        // Energy Indicator
        "Today's Charge": 'مقدار شارژ امروز',
        "Today's Discharge": 'مقدار دشارژ امروز',
        "Today's Generation": 'مقدار تولید برق امروز',
        'Total Fuel Consumption': 'کل مصرف سوخت',
        'Total Charge': 'کل شارژ',
        'Total Discharge': 'کل دشارژ',
        'Total Generation': 'کل تولید برق',
        'Total Revenue': 'کل درآمد',
        'Total Photovoltaic Generation': 'کل تولید برق خورشیدی',
        'Total EV Charger Consumption': 'کل مصرف برق ایستگاه شارژ',
        'Total Load Consumption': 'کل مصرف برق بار',
        'Total Grid Buy': 'کل خرید برق از شبکه',
        'Total Grid Sell': 'کل فروش برق به شبکه',
        'Total Efficiency': 'کارایی جامع',
        'Discharge Achievement Rate': 'نرخ تحقق دشارژ',
        // Revenue Indicator
        "Today's Cost": 'هزینه امروز',
        "Today's Income": 'درآمد امروز',
        "Total Cost": 'هزینه تجمعی',
        "Total Income": 'درآمد تجمعی',
        "Today's Revenue": 'سود امروز',

        'Revenue Ranking': 'رتبه‌بندی درآمد',
        'Efficiency Ranking': 'رتبه‌بندی کارایی',
        'Charge Ranking': 'رتبه‌بندی شارژ',
        'Discharge Ranking': 'رتبه‌بندی دشارژ',
        'Number of Microgrids': 'تعداد ریزشبکه‌ها',
        'Number of Power Stations': 'تعداد نیروگاه‌ها',
        'Microgrid List': 'لیست ریزشبکه‌ها',
        'Select Microgrid': 'انتخاب ریزشبکه',
        'Previous Page': 'صفحه قبل',
        'Next Page': 'صفحه بعد',
        '7 Days': '۷ روز',
        'Charge UNIT': 'شارژ {{UNIT}}',
        'Discharge UNIT': 'دشارژ {{UNIT}}',
        'Generation UNIT': 'تولید برق {{UNIT}}',
        'Energy Indicator': 'انرژی',
        'Revenue Indicator': 'درآمد',
        'Carbon Indicator': 'کربن',

        // Energy Storage Power Station
        'Battery Operating State': 'وضعیت عملکرد باتری',
        'Battery State': 'وضعیت باتری',
        'Battery Unknown': 'ناشناخته',
        'Battery Stopped': 'متوقف',
        'Battery Reserved': 'رزرو شده',
        'Battery Fault': 'خرابی',
        'Battery Warning': 'هشدار',
        'Battery Standby': 'آماده‌به‌کار',
        'Battery Prohibit DisCharging': 'ممنوعیت دشارژ',
        'Battery Prohibit Charging': 'ممنوعیت شارژ',
        'Battery Normal': 'عادی',
        'Battery Charging': 'در حال شارژ',
        'Battery Discharging': 'در حال دشارژ',
        'Battery Idle': 'بیکار',
        'Phase of Lifecycle': 'مرحله',
        'Use Phase': 'بهره‌برداری',
        'Commissioning Phase': 'راه‌اندازی',
        'Commissioning Date': 'تاریخ راه‌اندازی',
        'Installation Phase': 'در حال ساخت',
        'Device Status': 'وضعیت دستگاه',
        'Basic Information': 'اطلاعات پایه',
        'Gateway': 'دروازه',
        'Grid Meter': 'کنتور شبکه',
        'Load Meter': 'کنتور بار',
        'ESS Meter': 'کنتور ذخیره‌ساز',
        'Total Active Power': 'توان اکتیو کل',
        'Active Power A': 'توان اکتیو فاز A',
        'Active Power B': 'توان اکتیو فاز B',
        'Active Power C': 'توان اکتیو فاز C',
        'Total Reactive Power': 'توان راکتیو کل',
        'Reactive Power A': 'توان راکتیو فاز A',
        'Reactive Power B': 'توان راکتیو فاز B',
        'Reactive Power C': 'توان راکتیو فاز C',
        'Total Apparent Power': 'توان ظاهری کل',
        'Apparent Power A': 'توان ظاهری فاز A',
        'Apparent Power B': 'توان ظاهری فاز B',
        'Apparent Power C': 'توان ظاهری فاز C',
        'Total Power Factor': 'ضریب توان کل',
        'Active Energy Import': 'انرژی اکتیو ورودی',
        'Active Energy Export': 'انرژی اکتیو خروجی',
        'Active Energy Net': 'انرژی اکتیو خالص',

        'Generator': 'ژنراتور',

        // Photovoltaic Power Station
        'Invertor': 'اینورتر',
        'Invertor Run State': 'وضعیت عملکرد اینورتر',
        'Invertor Unknown': 'ناشناخته',
        'Invertor Initializing': 'روشن‌شدن اولیه',
        'Invertor Standby': 'آماده‌به‌کار',
        'Invertor Shutdown': 'خاموش',
        'Invertor Fault': 'خرابی',
        'Invertor Running': 'در حال کار',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': 'زمان ایجاد',
        'File Format': 'فرمت فایل',
        'File Size': 'حجم فایل',
        Uploader: 'بارگذاری‌کننده',
        'Upload Datetime': 'زمان بارگذاری',
        //Error
        "The page you're looking for is not found": 'صفحه مورد نظر شما یافت نشد',
        "Make sure the address is correct and that the page hasn't moved": 'لطفاً از صحت آدرس و جابه‌جا نشدن صفحه اطمینان حاصل کنید',
        'If you think this is a mistake,': 'اگر فکر می‌کنید این یک اشتباه است،',
        'contact us': 'با ما تماس بگیرید',
        'Take me home': 'به صفحه اصلی بروید',
        'Whoops, something went wrong!': 'اوه، خطایی رخ داد!',
        'Try refreshing the page, or going back and attempting the action again':
            'صفحه را بازخوانی کنید یا به صفحه قبل بازگشته و دوباره تلاش کنید',
        'If this problem persists,': 'اگر این مشکل ادامه یافت،',
        'Captcha Error': 'خطای کد امنیتی',
        'Confirm Password Error': 'تکرار رمز عبور مطابقت ندارد',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'به نظر می‌رسد روی یک لینک بازنشانی رمز عبور نامعتبر کلیک کرده‌اید. لطفاً دوباره تلاش کنید.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'به نظر می‌رسد روی یک لینک ثبت‌نام حساب کاربری نامعتبر کلیک کرده‌اید. لطفاً دوباره تلاش کنید.',
        //Tenant Bill
        'Lease Contract Number': 'شماره قرارداد اجاره',
        Download: 'دانلود',
        Print: 'چاپ',
        'Payment Notice': 'اطلاعیه پرداخت',
        'Bill To': 'گیرنده',
        'Bill Number': 'شماره صورتحساب',
        'Bill Date': 'تاریخ صورتحساب',
        'Payment Due Date': 'تاریخ سررسید پرداخت',
        'Amount Payable': 'مبلغ قابل پرداخت',
        'Billing Period Start': 'تاریخ شروع دوره صورتحساب',
        'Billing Period End': 'تاریخ پایان دوره صورتحساب',
        Quantity: 'مقدار',
        Price: 'قیمت',
        Unit: 'واحد',
        Amount: 'مبلغ',
        Subtotal: 'جمع جزء',
        'VAT Output Tax': 'مالیات بر ارزش افزوده فروش',
        'Total Amount Payable': 'جمع کل مبلغ قابل پرداخت',
        'Please make sure to pay on or before the payment due date above': 'لطفاً اطمینان حاصل کنید که در تاریخ سررسید پرداخت ذکر شده یا قبل از آن پرداخت را انجام دهید',
        'Send money to the following account': 'وجه را به حساب زیر واریز کنید',
        'Account Name': 'نام حساب',
        'Bank Name': 'بانک',
        'Bank Address': 'آدرس بانک',
        'RMB Account': 'حساب یوان',
        // button
        'Toggle Navigation': 'تغییر وضعیت ناوبری',
        // working calendar
        'Working Days': 'روزهای کاری',
        'Non Working Days': 'روزهای غیرکاری',
        'Select Row': 'لطفاً ردیف داده را برای عملیات انتخاب کنید',
        // Offline Meter Input
        'Daily Value': 'داده روزانه',
        Date: 'تاریخ',
        'Successfully Saved': 'با موفقیت ذخیره شد',
        'Previous Data Is Empty': 'داده قبلی خالی است',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'رفع قفل حساب ناموفق بود',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'نشست مدیر یافت نشد',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'نشست مدیر منقضی شده است',
        'API.ADVANCED_REPORT_NOT_FOUND': 'گزارش پیشرفته یافت نشد',
        'API.API_KEY_HAS_EXPIRED': 'کلید منقضی شده است',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'نام کلید قبلاً استفاده شده است',
        'API.API_KEY_NOT_FOUND': 'کلید یافت نشد',
        'API.BAD_REQUEST': 'درخواست نادرست',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'نقطه قیمت متعادل‌ساز یافت نشد',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'نقطه وضعیت باتری یافت نشد',
        'API.BUY_METER_NOT_FOUND': 'کنتور خرید یافت نشد',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'نمی‌توان کنتوری که قبلاً به عنوان کنتور فرعی تعیین شده را به کنتور اصلی تبدیل کرد',
        'API.CHARGE_METER_NOT_FOUND': 'کنتور شارژ یافت نشد',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و دستور وجود دارد',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و دستور یافت نشد',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و تجهیزات وجود دارد',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و تجهیزات یافت نشد',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و کنتور وجود دارد',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و کنتور یافت نشد',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'نام تجهیزات ترکیبی قبلاً استفاده شده است',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'تجهیزات ترکیبی یافت نشد',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و کنتور آفلاین وجود دارد',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و کنتور آفلاین یافت نشد',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'نام پارامتر مرتبط با تجهیزات ترکیبی قبلاً استفاده شده است',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'پارامتر مرتبط با تجهیزات ترکیبی یافت نشد یا مطابقت ندارد',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و کنتور مجازی وجود دارد',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و کنتور مجازی یافت نشد',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'نام دستور قبلاً استفاده شده است',
        'API.COMMAND_NOT_FOUND': 'دستور یافت نشد',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'نام مخاطب قبلاً استفاده شده است',
        'API.CONTACT_NOT_FOUND': 'مخاطب یافت نشد',
        'API.COOLING_METER_NOT_FOUND': 'کنتور سرمایش یافت نشد',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'شناسه خارجی مرکز هزینه از قبل وجود دارد',
        'API.COST_CENTER_NAME_EXISTS': 'نام مرکز هزینه از قبل وجود دارد',
        'API.COST_CENTER_NOT_FOUND': 'مرکز هزینه یافت نشد',
        'API.COST_FILE_NOT_FOUND': 'فایل هزینه یافت نشد',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'فایل تعمیر داده یافت نشد',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'نام منبع داده قبلاً استفاده شده است',
        'API.DATA_SOURCE_NOT_FOUND': 'منبع داده یافت نشد',
        'API.DATABASE_ERROR': 'خطای پایگاه داده',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'تاریخ از قبل در تقویم کاری وجود دارد',
        'API.DATE_LOCAL_NOT_FOUND': 'تاریخ محلی یافت نشد',
        'API.DISCHARGE_METER_NOT_FOUND': 'کنتور دشارژ یافت نشد',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'نام مدار توزیع قبلاً استفاده شده است',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'مدار توزیع یافت نشد',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'رابطه مدار توزیع و نقطه وجود دارد',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'رابطه مدار توزیع و نقطه یافت نشد',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'نام سیستم توزیع قبلاً استفاده شده است',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'سیستم توزیع یافت نشد',
        'API.ELECTRICITY_METER_NOT_FOUND': 'کنتور برق یافت نشد',
        'API.EMAIL_IS_ALREADY_IN_USE': 'آدرس ایمیل قبلاً استفاده شده است',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'پیام ایمیل یافت نشد',
        'API.EMAIL_NOT_FOUND': 'آدرس ایمیل یافت نشد',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'میزبان سرور ایمیل قبلاً استفاده شده است',
        'API.EMAIL_SERVER_NOT_FOUND': 'سرور ایمیل یافت نشد',
        'API.EMPTY_VARIABLES_ARRAY': 'آرایه متغیرها خالی است',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'نام دسته‌بندی انرژی قبلاً استفاده شده است',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'دسته‌بندی انرژی یافت نشد',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'دسته‌بندی انرژی در آیتم‌های انرژی استفاده شده است',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'دسته‌بندی انرژی در کنتور استفاده شده است',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'دسته‌بندی انرژی در کنتور آفلاین استفاده شده است',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'دسته‌بندی انرژی در تعرفه‌ها استفاده شده است',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'دسته‌بندی انرژی در کنتور مجازی استفاده شده است',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'لینک نمودار جریان انرژی قبلاً استفاده شده است',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'لینک نمودار جریان انرژی یافت نشد یا مطابقت ندارد',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'نام نمودار جریان انرژی قبلاً استفاده شده است',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'گره نمودار جریان انرژی قبلاً استفاده شده است',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'گره نمودار جریان انرژی یافت نشد یا مطابقت ندارد',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'نمودار جریان انرژی یافت نشد',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'آیتم انرژی به دسته‌بندی انرژی تعلق ندارد',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'آیتم انرژی به دسته‌بندی انرژی تعلق ندارد',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'آیتم انرژی قبلاً استفاده شده است',
        'API.ENERGY_ITEM_NOT_FOUND': 'آیتم انرژی یافت نشد',
        'API.ENERGY_ITEM_USED_IN_METER': 'آیتم انرژی در کنتور استفاده شده است',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'آیتم انرژی در کنتور آفلاین استفاده شده است',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'آیتم انرژی در کنتور مجازی استفاده شده است',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'نام نیروگاه ذخیره‌ساز انرژی قبلاً استفاده شده است',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'نیروگاه ذخیره‌ساز انرژی یافت نشد',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'رابطه تجهیزات و دستور وجود دارد',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'رابطه تجهیزات و دستور یافت نشد',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'رابطه تجهیزات و کنتور وجود دارد',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات و کنتور یافت نشد',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'نام تجهیزات قبلاً استفاده شده است',
        'API.EQUIPMENT_NOT_FOUND': 'تجهیزات یافت نشد',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'رابطه تجهیزات و کنتور آفلاین وجود دارد',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات و کنتور آفلاین یافت نشد',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'نام پارامتر مرتبط با تجهیزات قبلاً استفاده شده است',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'پارامتر مرتبط با تجهیزات یافت نشد یا مطابقت ندارد',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'رابطه تجهیزات و کنتور مجازی وجود دارد',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات و کنتور مجازی یافت نشد',
        'API.ERROR': 'خطا',
        'API.EXCEPTION': 'استثنا',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'خواندن جریان درخواست ناموفق بود',
        'API.FAILED_TO_RESTORE_COST_FILE': 'بازیابی فایل هزینه ناموفق بود',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'بازیابی فایل تعمیر داده ناموفق بود',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'بازیابی فایل دانش ناموفق بود',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'بازیابی فایل کنتور آفلاین ناموفق بود',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'ذخیره فایل کنتور آفلاین ناموفق بود',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'بارگذاری فایل پیوست ناموفق بود',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'بارگذاری فایل هزینه ناموفق بود',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'بارگذاری فایل تعمیر داده ناموفق بود',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'بارگذاری فایل دانش ناموفق بود',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'بارگذاری فایل کنتور آفلاین ناموفق بود',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'نام دروازه قبلاً استفاده شده است',
        'API.GATEWAY_NOT_FOUND': 'دروازه یافت نشد',
        'API.HEAT_METER_NOT_FOUND': 'کنتور گرمایش یافت نشد',
        'API.INVALID_': 'نامعتبر ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'کد تأیید نامعتبر است',
        'API.INVALID_ADDRESS': 'آدرس نامعتبر',
        'API.INVALID_ADDRESS_VALUE': 'مقدار آدرس نامعتبر',
        'API.INVALID_ADVANCED_REPORT_ID': 'شناسه گزارش پیشرفته نامعتبر',
        'API.INVALID_API_KEY_ID': 'شناسه کلید API نامعتبر',
        'API.INVALID_API_KEY_NAME': 'نام کلید API نامعتبر',
        'API.INVALID_AREA_VALUE': 'مقدار مساحت نامعتبر',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'شناسه نقطه قیمت متعادل‌ساز نامعتبر',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'زمان پایان دوره پایه نامعتبر',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'زمان شروع دوره پایه نامعتبر',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'شناسه نقطه وضعیت باتری نامعتبر',
        'API.INVALID_BAUD_RATE': 'نرخ باود نامعتبر',
        'API.INVALID_BUILDINGS_VALUE': 'مقدار ساختمان نامعتبر',
        'API.INVALID_BUY_METER_ID': 'شناسه کنتور خرید نامعتبر',
        'API.INVALID_CAPACITY': 'ظرفیت نامعتبر',
        'API.INVALID_CATEGORY': 'دسته نامعتبر',
        'API.INVALID_CHANNEL': 'کانال نامعتبر',
        'API.INVALID_CHARGE_METER_ID': 'شناسه کنتور شارژ نامعتبر',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'شناسه تجهیزات ترکیبی نامعتبر',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'نام تجهیزات ترکیبی نامعتبر',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'شناسه پارامتر مرتبط با تجهیزات ترکیبی نامعتبر',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'نام پارامتر مرتبط با تجهیزات ترکیبی نامعتبر',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'نوع پارامتر مرتبط با تجهیزات ترکیبی نامعتبر',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'UUID تجهیزات ترکیبی نامعتبر',
        'API.INVALID_COMMAND_ID': 'شناسه دستور نامعتبر',
        'API.INVALID_COMMAND_NAME': 'نام دستور نامعتبر',
        'API.INVALID_CONNECTION': 'اتصال نامعتبر',
        'API.INVALID_CONSTANT_VALUE': 'مقدار ثابت نامعتبر',
        'API.INVALID_CONTACT_ID': 'شناسه مخاطب نامعتبر',
        'API.INVALID_CONTACT_NAME': 'نام مخاطب نامعتبر',
        'API.INVALID_COOLING_METER_ID': 'شناسه کنتور سرمایش نامعتبر',
        'API.INVALID_COST_CENTER_ID': 'شناسه مرکز هزینه نامعتبر',
        'API.INVALID_COST_FILE_ID': 'شناسه فایل هزینه نامعتبر',
        'API.INVALID_CREATED_DATETIME': 'زمان ایجاد نامعتبر',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'شناسه فایل تعمیر داده نامعتبر',
        'API.INVALID_DATA_SOURCE_ID': 'شناسه منبع داده نامعتبر',
        'API.INVALID_DATA_SOURCE_NAME': 'نام منبع داده نامعتبر',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'پروتکل منبع داده نامعتبر',
        'API.INVALID_DATE_LOCAL': 'تاریخ محلی نامعتبر',
        'API.INVALID_DENOMINATOR_METER_UUID': 'UUID کنتور استاندارد نامعتبر',
        'API.INVALID_DISCHARGE_METER_ID': 'شناسه کنتور دشارژ نامعتبر',
        'API.INVALID_DISPLAY_NAME': 'نام نمایشی نامعتبر',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'شناسه مدار توزیع نامعتبر',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'نام مدار توزیع نامعتبر',
        'API.INVALID_DISTRIBUTION_ROOM': 'اتاق توزیع نامعتبر',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'شناسه سیستم توزیع نامعتبر',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'نام سیستم توزیع نامعتبر',
        'API.INVALID_ELECTRICITY_METER_ID': 'شناسه کنتور برق نامعتبر',
        'API.INVALID_EMAIL': 'ایمیل نامعتبر',
        'API.INVALID_EMAIL_MESSAGE_ID': 'شناسه پیام ایمیل نامعتبر',
        'API.INVALID_EMAIL_SERVER_HOST': 'میزبان سرور ایمیل نامعتبر',
        'API.INVALID_EMAIL_SERVER_ID': 'شناسه سرور ایمیل نامعتبر',
        'API.INVALID_END_DATE_FORMAT': 'فرمت تاریخ پایان نامعتبر',
        'API.INVALID_END_DATETIME': 'تاریخ پایان نامعتبر',
        'API.INVALID_ENERGY_CATEGORY_ID': 'شناسه دسته‌بندی انرژی نامعتبر',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'نام دسته‌بندی انرژی نامعتبر',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'شناسه نمودار جریان انرژی نامعتبر',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'شناسه لینک نمودار جریان انرژی نامعتبر',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'نام نمودار جریان انرژی نامعتبر',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'شناسه گره نمودار جریان انرژی نامعتبر',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'نام گره نمودار جریان انرژی نامعتبر',
        'API.INVALID_ENERGY_ITEM_ID': 'شناسه آیتم انرژی نامعتبر',
        'API.INVALID_ENERGY_ITEM_NAME': 'نام آیتم انرژی نامعتبر',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'شناسه نیروگاه ذخیره‌ساز انرژی نامعتبر',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'نام نیروگاه ذخیره‌ساز انرژی نامعتبر',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'معادله نامعتبر در عبارت',
        'API.INVALID_EQUIPMENT_ID': 'شناسه تجهیزات نامعتبر',
        'API.INVALID_EQUIPMENT_NAME': 'نام تجهیزات نامعتبر',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'شناسه پارامتر مرتبط با تجهیزات نامعتبر',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'نام پارامتر مرتبط با تجهیزات نامعتبر',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'نوع پارامتر مرتبط با تجهیزات نامعتبر',
        'API.INVALID_EQUIPMENT_UUID': 'UUID تجهیزات نامعتبر',
        'API.INVALID_EXPIRES_DATETIME': 'تاریخ انقضا نامعتبر',
        'API.INVALID_EXPRESSION': 'عبارت نامعتبر',
        'API.INVALID_EXPRESSION_OBJECT': 'شیء عبارت نامعتبر',
        'API.INVALID_FDD_CODE': 'کد خطای خرابی نامعتبر',
        'API.INVALID_FLOORS_VALUE': 'مقدار طبقه نامعتبر',
        'API.INVALID_FROM_ADDR': 'آدرس مبدأ نامعتبر',
        'API.INVALID_GATEWAY_ID': 'شناسه دروازه نامعتبر',
        'API.INVALID_GATEWAY_NAME': 'نام دروازه نامعتبر',
        'API.INVALID_HEAT_METER_ID': 'شناسه کنتور گرمایش نامعتبر',
        'API.INVALID_HIGH_LIMIT_VALUE': 'مقدار حد بالا نامعتبر',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'مقدار حد بالای ساعتی نامعتبر',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'مقدار حد پایین ساعتی نامعتبر',
        'API.INVALID_Id': 'شناسه نامعتبر',
        'API.INVALID_IS_ADMIN_VALUE': 'مقدار مدیریت نامعتبر',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'نمایش داده هزینه نامعتبر',
        'API.INVALID_IS_COUNTED_VALUE': 'مقدار شمارش نامعتبر',
        'API.INVALID_IS_ENABLED': 'فعال بودن نامعتبر',
        'API.INVALID_IS_HIDDEN': 'مخفی بودن نامعتبر',
        'API.INVALID_IS_IN_LEASE_VALUE': 'مقدار در اجاره بودن نامعتبر',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'مقدار جمع‌آوری ورودی نامعتبر',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'مقدار مستأجر اصلی بودن نامعتبر',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'مقدار جمع‌آوری خروجی نامعتبر',
        'API.INVALID_IS_OUTPUT_VALUE': 'مقدار جمع‌آوری خروجی نامعتبر',
        'API.INVALID_IS_READ_ONLY_VALUE': 'مقدار فقط خواندنی نامعتبر',
        'API.INVALID_IS_TREND_VALUE': 'مقدار ذخیره روند نامعتبر',
        'API.INVALID_IS_VIRTUAL_VALUE': 'مقدار نقطه مجازی نامعتبر',
        'API.INVALID_KGCE': 'ضریب تبدیل به کیلوگرم زغال سنگ استاندارد نامعتبر',
        'API.INVALID_KGCO2E': 'ضریب انتشار دی‌اکسید کربن به کیلوگرم نامعتبر',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'شناسه فایل دانش نامعتبر',
        'API.INVALID_LATITUDE_VALUE': 'مقدار عرض جغرافیایی نامعتبر',
        'API.INVALID_LEASE_NUMBER_VALUE': 'شماره قرارداد اجاره نامعتبر',
        'API.INVALID_LONGITUDE_VALUE': 'مقدار طول جغرافیایی نامعتبر',
        'API.INVALID_LOW_LIMIT_VALUE': 'مقدار حد پایین نامعتبر',
        'API.INVALID_MASTER_METER_ID': 'شناسه کنتور اصلی نامعتبر',
        'API.INVALID_MENU_ID': 'شناسه منو نامعتبر',
        'API.INVALID_MESSAGE_DATA': 'داده پیام نامعتبر',
        'API.INVALID_MESSAGE_TEMPLATE': 'قالب پیام نامعتبر',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'شناسه قالب پیام نامعتبر',
        'API.INVALID_MESSAGE_VALUE': 'مقدار پیام نامعتبر',
        'API.INVALID_METER_ID': 'شناسه کنتور نامعتبر',
        'API.INVALID_METER_NAME': 'نام کنتور نامعتبر',
        'API.INVALID_METER_UUID': 'UUID کنتور نامعتبر',
        'API.INVALID_MICROGRID_BATTERY_ID': 'شناسه باتری ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'نام باتری ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'شناسه ایستگاه شارژ ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'نام ایستگاه شارژ ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'شناسه ژنراتور ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'نام ژنراتور ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_GRID_ID': 'شناسه شبکه ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_GRID_NAME': 'نام شبکه ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'شناسه پمپ حرارتی ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'نام پمپ حرارتی ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_ID': 'شناسه ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_LOAD_ID': 'شناسه بار ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_LOAD_NAME': 'نام بار ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_NAME': 'نام ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'شناسه فتوولتائیک ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'نام فتوولتائیک ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'شناسه سیستم تبدیل توان ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'نام سیستم تبدیل توان ریزشبکه نامعتبر',
        'API.INVALID_MICROGRID_UUID': 'UUID ریزشبکه نامعتبر',
        'API.INVALID_NAME_VALUE': 'مقدار نام نامعتبر',
        'API.INVALID_NEW_PASSWORD': 'رمز عبور جدید نامعتبر',
        'API.INVALID_NON_WORKING_DAY_ID': 'شناسه روز غیرکاری نامعتبر',
        'API.INVALID_NOTIFICATION_ID': 'شناسه اعلان نامعتبر',
        'API.INVALID_NUMERATOR_METER_UUID': 'UUID کنتور صورت کسر نامعتبر',
        'API.INVALID_OBJECT_TYPE': 'نوع شیء نامعتبر',
        'API.INVALID_OFFLINE_METER_DATA': 'داده کنتور آفلاین نامعتبر',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'شناسه فایل کنتور آفلاین نامعتبر',
        'API.INVALID_OFFLINE_METER_ID': 'شناسه کنتور آفلاین نامعتبر',
        'API.INVALID_OFFLINE_METER_NAME': 'نام کنتور آفلاین نامعتبر',
        'API.INVALID_OFFLINE_METER_UUID': 'UUID کنتور آفلاین نامعتبر',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'ثابت افست نامعتبر',
        'API.INVALID_OLD_PASSWORD': 'رمز عبور قدیمی نامعتبر',
        'API.INVALID_OPENID': 'شناسه باز نامعتبر',
        'API.INVALID_PARENT_SPACE_ID': 'شناسه فضای والد نامعتبر',
        'API.INVALID_PASSWORD': 'رمز عبور نامعتبر',
        'API.INVALID_PAYLOAD': 'بار محموله نامعتبر',
        'API.INVALID_PEAK_CURRENT': 'جریان پیک نامعتبر',
        'API.INVALID_PEAK_LOAD': 'بار پیک نامعتبر',
        'API.INVALID_PERIOD_TYPE': 'نوع دوره نامعتبر',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'شناسه نیروگاه فتوولتائیک نامعتبر',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'نام نیروگاه فتوولتائیک نامعتبر',
        'API.INVALID_POINT_ID': 'شناسه نقطه داده نامعتبر',
        'API.INVALID_POINT_NAME': 'نام نقطه داده نامعتبر',
        'API.INVALID_PORT': 'پورت نامعتبر',
        'API.INVALID_POSTAL_CODE_VALUE': 'مقدار کد پستی نامعتبر',
        'API.INVALID_POWER_POINT_ID': 'شناسه نقطه توان نامعتبر',
        'API.INVALID_PRIORITY': 'اولویت نامعتبر',
        'API.INVALID_PRIVILEGE': 'دسترسی نامعتبر',
        'API.INVALID_PRIVILEGE_DATA': 'داده دسترسی نامعتبر',
        'API.INVALID_PRIVILEGE_ID': 'شناسه دسترسی نامعتبر',
        'API.INVALID_PRIVILEGE_NAME': 'نام دسترسی نامعتبر',
        'API.INVALID_RATIO_VALUE': 'مقدار نسبت تبدیل نامعتبر',
        'API.INVALID_RECIPIENT_EMAIL': 'ایمیل گیرنده نامعتبر',
        'API.INVALID_RECIPIENT_MOBILE': 'موبایل گیرنده نامعتبر',
        'API.INVALID_RECIPIENT_NAME': 'نام گیرنده نامعتبر',
        'API.INVALID_RECIPIENT_OPENID': 'شناسه باز گیرنده نامعتبر',
        'API.INVALID_REPLY': 'پاسخ نامعتبر',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'تاریخ و زمان پایان دوره گزارش نامعتبر',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'تاریخ و زمان شروع دوره گزارش نامعتبر',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'نیاز به احراز هویت نامعتبر',
        'API.INVALID_ROOMS_VALUE': 'مقدار اتاق نامعتبر',
        'API.INVALID_RULE_ID': 'شناسه قانون نامعتبر',
        'API.INVALID_RULE_NAME': 'نام قانون نامعتبر',
        'API.INVALID_RUN_STATE_POINT_ID': 'شناسه نقطه وضعیت عملکرد نامعتبر',
        'API.INVALID_SCHEDULED_DATETIME': 'تاریخ زمان‌بندی شده نامعتبر',
        'API.INVALID_SELL_METER_ID': 'شناسه کنتور فروش نامعتبر',
        'API.INVALID_SENSOR_ID': 'شناسه سنسور نامعتبر',
        'API.INVALID_SENSOR_NAME': 'نام سنسور نامعتبر',
        'API.INVALID_SENSOR_UUID': 'UUID سنسور نامعتبر',
        'API.INVALID_SERIAL_NUMBER': 'شماره سریال نامعتبر',
        'API.INVALID_SERIAL_PORT': 'پورت سریال نامعتبر',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'نشست نامعتبر است، لطفاً دوباره وارد شوید',
        'API.INVALID_SET_VALUE': 'مقدار تنظیم شده نامعتبر',
        'API.INVALID_SHOPFLOOR_ID': 'شناسه کارگاه نامعتبر',
        'API.INVALID_SHOPFLOOR_NAME': 'نام کارگاه نامعتبر',
        'API.INVALID_SHOPFLOOR_UUID': 'UUID کارگاه نامعتبر',
        'API.INVALID_SOURCE_NODE_ID': 'شناسه گره مبدأ نامعتبر',
        'API.INVALID_SPACE_ID': 'شناسه فضا نامعتبر',
        'API.INVALID_SPACE_NAME': 'نام فضا نامعتبر',
        'API.INVALID_SPACE_UUID': 'UUID فضا نامعتبر',
        'API.INVALID_START_DATE_FORMAT': 'فرمت تاریخ شروع نامعتبر',
        'API.INVALID_START_DATETIME': 'تاریخ شروع نامعتبر',
        'API.INVALID_STATUS': 'وضعیت نامعتبر',
        'API.INVALID_STORE_ID': 'شناسه فروشگاه نامعتبر',
        'API.INVALID_STORE_NAME': 'نام فروشگاه نامعتبر',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'توضیحات نوع فروشگاه نامعتبر',
        'API.INVALID_STORE_TYPE_ID': 'شناسه نوع فروشگاه نامعتبر',
        'API.INVALID_STORE_TYPE_NAME': 'نام نوع فروشگاه نامعتبر',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'کد ساده‌شده نوع فروشگاه نامعتبر',
        'API.INVALID_STORE_UUID': 'UUID فروشگاه نامعتبر',
        'API.INVALID_SUBJECT_VALUE': 'مقدار موضوع نامعتبر',
        'API.INVALID_SVG': 'SVG نامعتبر',
        'API.INVALID_SWITCHGEAR': 'تابلوی برق نامعتبر',
        'API.INVALID_TARGET_NODE_ID': 'شناسه گره مقصد نامعتبر',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'قیمت‌گذاری پلکانی تعرفه نامعتبر',
        'API.INVALID_TARIFF_ID': 'شناسه تعرفه نامعتبر',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'قیمت‌گذاری زمان مصرف تعرفه نامعتبر',
        'API.INVALID_TARIFF_TYPE': 'نوع تعرفه نامعتبر',
        'API.INVALID_TENANT_ID': 'شناسه مستأجر نامعتبر',
        'API.INVALID_TENANT_NAME': 'نام مستأجر نامعتبر',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'توضیحات نوع مستأجر نامعتبر',
        'API.INVALID_TENANT_TYPE_ID': 'شناسه نوع مستأجر نامعتبر',
        'API.INVALID_TENANT_TYPE_NAME': 'نام نوع مستأجر نامعتبر',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'کد ساده‌شده نوع مستأجر نامعتبر',
        'API.INVALID_TENANT_UUID': 'UUID مستأجر نامعتبر',
        'API.INVALID_TEXT_MESSAGE_ID': 'شناسه پیامک نامعتبر',
        'API.INVALID_TIMEZONE_ID': 'شناسه منطقه زمانی نامعتبر',
        'API.INVALID_TOKEN': 'توکن نامعتبر',
        'API.INVALID_TOPIC': 'موضوع نامعتبر',
        'API.INVALID_UNIT_OF_MEASURE': 'واحد اندازه‌گیری نامعتبر',
        'API.INVALID_UNIT_OF_PRICE': 'واحد قیمت نامعتبر',
        'API.INVALID_UNITS': 'واحد نامعتبر',
        'API.INVALID_USER_ID': 'شناسه کاربر نامعتبر',
        'API.INVALID_USER_NAME': 'نام کاربری نامعتبر',
        'API.INVALID_USER_NAME_OR_EMAIL': 'نام کاربری یا ایمیل نامعتبر',
        'API.INVALID_USER_PHONE': 'شماره تلفن کاربر نامعتبر',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'کاربر نامعتبر است، لطفاً دوباره وارد شوید',
        'API.INVALID_USER_UUID': 'UUID کاربر نامعتبر',
        'API.INVALID_USERNAME': 'نام کاربری نامعتبر',
        'API.INVALID_VARIABLE_METER_ID': 'شناسه کنتور متغیر نامعتبر',
        'API.INVALID_VARIABLE_METER_TYPE': 'نوع کنتور متغیر نامعتبر',
        'API.INVALID_VARIABLE_NAME': 'نام متغیر نامعتبر',
        'API.INVALID_VERIFICATION_CODE': 'کد تأیید نامعتبر',
        'API.INVALID_VIRTUAL_METER_ID': 'شناسه کنتور مجازی نامعتبر',
        'API.INVALID_VIRTUAL_METER_NAME': 'نام کنتور مجازی نامعتبر',
        'API.INVALID_VIRTUAL_METER_UUID': 'UUID کنتور مجازی نامعتبر',
        'API.INVALID_WEB_MESSAGE_ID': 'شناسه پیام وب نامعتبر',
        'API.INVALID_WECHAT_MESSAGE_ID': 'شناسه پیام وی‌چت نامعتبر',
        'API.INVALID_WIND_FARM_ID': 'شناسه مزرعه بادی نامعتبر',
        'API.INVALID_WIND_FARM_NAME': 'نام مزرعه بادی نامعتبر',
        'API.INVALID_WORKING_CALENDAR_ID': 'شناسه تقویم کاری نامعتبر',
        'API.INVALID_WORKING_CALENDAR_NAME': 'نام تقویم کاری نامعتبر',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'امکان حذف فایل دانش از دیسک وجود ندارد',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'فایل پایگاه دانش یافت نشد',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'کنتور اصلی به همان دسته‌بندی انرژی تعلق ندارد',
        'API.MASTER_METER_NOT_FOUND': 'کنتور اصلی یافت نشد',
        'API.MENU_NOT_FOUND': 'منو یافت نشد',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'کنتور نمی‌تواند بیش از یک نقطه مقدار انرژی داشته باشد',
        'API.METER_COMMAND_RELATION_EXISTS': 'رابطه کنتور و دستور وجود دارد',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'رابطه کنتور و دستور یافت نشد',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'نام کنتور قبلاً استفاده شده است',
        'API.METER_NOT_FOUND': 'کنتور یافت نشد',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'کنتور متغیر یافت نشد',
        'API.METER_POINT_RELATION_EXISTS': 'رابطه کنتور و نقطه داده وجود دارد',
        'API.METER_POINT_RELATION_NOT_FOUND': 'رابطه کنتور و نقطه داده یافت نشد',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'نام باتری ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'باتری ریزشبکه یافت نشد',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'نام ایستگاه شارژ ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'ایستگاه شارژ ریزشبکه یافت نشد',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'نام ژنراتور ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'ژنراتور ریزشبکه یافت نشد',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'نام شبکه ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_GRID_NOT_FOUND': 'شبکه ریزشبکه یافت نشد',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'نام پمپ حرارتی ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'پمپ حرارتی ریزشبکه یافت نشد',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'نام بار ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_LOAD_NOT_FOUND': 'بار ریزشبکه یافت نشد',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'نام ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_NOT_FOUND': 'ریزشبکه یافت نشد',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'نام فتوولتائیک ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'فتوولتائیک ریزشبکه یافت نشد',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'نام سیستم تبدیل توان ریزشبکه قبلاً استفاده شده است',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'سیستم تبدیل توان ریزشبکه یافت نشد',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'رابطه ریزشبکه و سنسور وجود دارد',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'رابطه ریزشبکه و سنسور یافت نشد',
        'API.MQTT_CONNECTION_ERROR': 'خطای اتصال MQTT',
        'API.MQTT_PUBLISH_ERROR': 'خطای انتشار MQTT',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'طول رمز عبور جدید نمی‌تواند بیش از ۱۰۰ کاراکتر باشد',
        'API.NEW_USER_SESSION_NOT_FOUND': 'نشست کاربر جدید یافت نشد',
        'API.NEW_USER_SESSION_TIMEOUT': 'نشست کاربر جدید منقضی شده است',
        'API.NON_WORKING_DAY_NOT_FOUND': 'روز غیرکاری یافت نشد',
        'API.NOT_FOUND': 'یافت نشد',
        'API.NOTIFICATION_NOT_FOUND': 'اعلان یافت نشد',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'فایل کنتور آفلاین یافت نشد',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'نام کنتور آفلاین قبلاً استفاده شده است',
        'API.OFFLINE_METER_NOT_FOUND': 'کنتور آفلاین یافت نشد',
        'API.INVALID_OFFLINE_METER_VALUE': 'مقدار کنتور آفلاین نامعتبر است',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'کنتور آفلاین متغیر یافت نشد',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'طول رمز عبور قدیمی نمی‌تواند بیش از ۱۰۰ کاراکتر باشد',
        'API.PARENT_SPACE_NOT_FOUND': 'فضای والد یافت نشد',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'طول رمز عبور نمی‌تواند بیش از ۱۰۰ کاراکتر باشد',
        'API.PASSWORDS_MATCH': 'رمز عبور جدید با رمز عبور قدیمی یکسان است',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'نام نیروگاه فتوولتائیک قبلاً استفاده شده است',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'نیروگاه فتوولتائیک یافت نشد',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'نام نقطه داده قبلاً استفاده شده است',
        'API.POINT_NOT_FOUND': 'نقطه داده یافت نشد',
        'API.POWER_POINT_NOT_FOUND': 'نقطه توان یافت نشد',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'نام دسترسی قبلاً استفاده شده است',
        'API.PRIVILEGE_NOT_FOUND': 'دسترسی یافت نشد',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'نام قانون قبلاً استفاده شده است',
        'API.RULE_NOT_FOUND': 'قانون یافت نشد',
        'API.SELL_METER_NOT_FOUND': 'کنتور فروش یافت نشد',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'نام سنسور قبلاً استفاده شده است',
        'API.SENSOR_NOT_FOUND': 'سنسور یافت نشد',
        'API.SENSOR_POINT_RELATION_EXISTS': 'رابطه سنسور و نقطه داده وجود دارد',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'رابطه سنسور و نقطه داده یافت نشد',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'رابطه کارگاه و دستور وجود دارد',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'رابطه کارگاه و دستور یافت نشد',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'رابطه کارگاه و تجهیزات وجود دارد',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'رابطه کارگاه و تجهیزات یافت نشد',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'رابطه کارگاه و کنتور وجود دارد',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'رابطه کارگاه و کنتور یافت نشد',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'نام کارگاه قبلاً استفاده شده است',
        'API.SHOPFLOOR_NOT_FOUND': 'کارگاه یافت نشد',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'رابطه کارگاه و کنتور آفلاین وجود دارد',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه کارگاه و کنتور آفلاین یافت نشد',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'رابطه کارگاه و نقطه داده وجود دارد',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'رابطه کارگاه و نقطه داده یافت نشد',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'رابطه کارگاه و سنسور وجود دارد',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'رابطه کارگاه و سنسور یافت نشد',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'رابطه کارگاه و کنتور مجازی وجود دارد',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه کارگاه و کنتور مجازی یافت نشد',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'رابطه کارگاه و تقویم کاری وجود دارد',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'رابطه کارگاه و تقویم کاری یافت نشد',
        'API.SOC_POINT_NOT_FOUND': 'نقطه SOC یافت نشد',
        'API.SOURCE_NODE_NOT_FOUND': 'گره مبدأ یافت نشد',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'رابطه فضا و تجهیزات ترکیبی وجود دارد',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'رابطه فضا و تجهیزات ترکیبی یافت نشد',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'رابطه فضا و دستور وجود دارد',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'رابطه فضا و دستور یافت نشد',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'رابطه فضا و نیروگاه ذخیره‌ساز انرژی وجود دارد',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'رابطه فضا و نیروگاه ذخیره‌ساز انرژی یافت نشد',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'رابطه فضا و تجهیزات وجود دارد',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'رابطه فضا و تجهیزات یافت نشد',
        'API.SPACE_METER_RELATION_EXISTS': 'رابطه فضا و کنتور وجود دارد',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'رابطه فضا و کنتور یافت نشد',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'نام فضا قبلاً استفاده شده است',
        'API.SPACE_NOT_FOUND': 'فضا یافت نشد',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'فضا در دسترسی‌ها یافت نشد',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'رابطه فضا و کنتور آفلاین وجود دارد',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه فضا و کنتور آفلاین یافت نشد',
        'API.SPACE_POINT_RELATION_EXISTS': 'رابطه فضا و نقطه داده وجود دارد',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'رابطه فضا و نقطه داده یافت نشد',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'رابطه فضا و سنسور وجود دارد',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'رابطه فضا و سنسور یافت نشد',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'رابطه فضا و کارگاه وجود دارد',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'رابطه فضا و کارگاه یافت نشد',
        'API.SPACE_STORE_RELATION_EXISTS': 'رابطه فضا و فروشگاه وجود دارد',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'رابطه فضا و فروشگاه یافت نشد',
        'API.SPACE_TENANT_RELATION_EXISTS': 'رابطه فضا و مستأجر وجود دارد',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'رابطه فضا و مستأجر یافت نشد',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'رابطه فضا و کنتور مجازی وجود دارد',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه فضا و کنتور مجازی یافت نشد',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'رابطه فضا و تقویم کاری وجود دارد',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'رابطه فضا و تقویم کاری یافت نشد',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'تاریخ و زمان شروع باید قبل از تاریخ و زمان پایان باشد',
        'API.STORE_COMMAND_RELATION_EXISTS': 'رابطه فروشگاه و دستور وجود دارد',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'رابطه فروشگاه و دستور یافت نشد',
        'API.STORE_METER_RELATION_EXISTS': 'رابطه فروشگاه و کنتور وجود دارد',
        'API.STORE_METER_RELATION_NOT_FOUND': 'رابطه فروشگاه و کنتور یافت نشد',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'نام فروشگاه قبلاً استفاده شده است',
        'API.STORE_NOT_FOUND': 'فروشگاه یافت نشد',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'رابطه فروشگاه و کنتور آفلاین وجود دارد',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه فروشگاه و کنتور آفلاین یافت نشد',
        'API.STORE_POINT_RELATION_EXISTS': 'رابطه فروشگاه و نقطه داده وجود دارد',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'رابطه فروشگاه و نقطه داده یافت نشد',
        'API.STORE_SENSOR_RELATION_EXISTS': 'رابطه فروشگاه و سنسور وجود دارد',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'رابطه فروشگاه و سنسور یافت نشد',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'نام نوع فروشگاه قبلاً استفاده شده است',
        'API.STORE_TYPE_NOT_FOUND': 'نوع فروشگاه یافت نشد',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'کد ساده‌شده نوع فروشگاه قبلاً استفاده شده است',
        'API.STORE_TYPE_USED_IN_STORE': 'نوع فروشگاه در فروشگاه استفاده شده است',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'رابطه فروشگاه و کنتور مجازی وجود دارد',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه فروشگاه و کنتور مجازی یافت نشد',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'رابطه فروشگاه و تقویم کاری وجود دارد',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'رابطه فروشگاه و تقویم کاری یافت نشد',
        'API.TARGET_NODE_NOT_FOUND': 'گره مقصد یافت نشد',
        'API.TARIFF_IN_USE': 'تعرفه در حال استفاده است',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'تعرفه و مرکز هزینه قبلاً مرتبط شده‌اند',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'تعرفه و مرکز هزینه مرتبط نیستند',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'نام تعرفه قبلاً استفاده شده است',
        'API.TARIFF_NOT_FOUND': 'تعرفه یافت نشد',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'رابطه مستأجر و دستور وجود دارد',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'رابطه مستأجر و دستور یافت نشد',
        'API.TENANT_METER_RELATION_EXISTS': 'رابطه مستأجر و کنتور وجود دارد',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'رابطه مستأجر و کنتور یافت نشد',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'نام مستأجر قبلاً استفاده شده است',
        'API.TENANT_NOT_FOUND': 'مستأجر یافت نشد',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'رابطه مستأجر و کنتور آفلاین وجود دارد',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه مستأجر و کنتور آفلاین یافت نشد',
        'API.TENANT_POINT_RELATION_EXISTS': 'رابطه مستأجر و نقطه داده وجود دارد',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'رابطه مستأجر و نقطه داده یافت نشد',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'رابطه مستأجر و سنسور وجود دارد',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'رابطه مستأجر و سنسور یافت نشد',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'نام نوع مستأجر قبلاً استفاده شده است',
        'API.TENANT_TYPE_NOT_FOUND': 'نوع مستأجر یافت نشد',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'کد ساده‌شده نوع مستأجر قبلاً استفاده شده است',
        'API.TENANT_TYPE_USED_IN_TENANT': 'نوع مستأجر در مستأجر استفاده شده است',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'رابطه مستأجر و کنتور مجازی وجود دارد',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه مستأجر و کنتور مجازی یافت نشد',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'رابطه مستأجر و تقویم کاری وجود دارد',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'رابطه مستأجر و تقویم کاری یافت نشد',
        'API.TEXT_MESSAGE_NOT_FOUND': 'پیامک یافت نشد',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'دوره گزارش باید بیشتر از ۱۵ دقیقه باشد',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'با کنتورهای فرعی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'با زیرفضاها رابطه دارد',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'با پارامترهای مرتبط با تجهیزات ترکیبی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'با تجهیزات ترکیبی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'با منابع داده رابطه دارد',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'با لینک‌های نمودار جریان انرژی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'با باتری‌های کانتینر ذخیره‌ساز انرژی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'با شبکه‌های کانتینر ذخیره‌ساز انرژی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'با بارهای کانتینر ذخیره‌ساز انرژی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'با سیستم‌های تبدیل توان (PCS) کانتینر ذخیره‌ساز انرژی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'با پارامترهای مرتبط با تجهیزات رابطه دارد',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'با تجهیزات رابطه دارد',
        'API.THERE_IS_RELATION_WITH_METER': 'با کنتور رابطه دارد',
        'API.THERE_IS_RELATION_WITH_METERS': 'با چندین کنتور رابطه دارد',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'با کنتور آفلاین رابطه دارد',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'با چندین کنتور آفلاین رابطه دارد',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'با کنتورهای مجازی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'با سنسورها رابطه دارد',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'با کارگاه‌ها رابطه دارد',
        'API.THERE_IS_RELATION_WITH_SPACES': 'با فضاها رابطه دارد',
        'API.THERE_IS_RELATION_WITH_STORES': 'با فروشگاه‌ها رابطه دارد',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'با مستأجران رابطه دارد',
        'API.THERE_IS_RELATION_WITH_USERS': 'با کاربران رابطه دارد',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'با کنتور مجازی رابطه دارد',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'با نیروگاه‌های مجازی رابطه دارد',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'این منبع داده توسط یک کنتور در حال استفاده است',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'این کنتور توسط یک کنتور مجازی در حال استفاده است',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'این کنتور آفلاین توسط یک کنتور مجازی در حال استفاده است',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'فضا قابل شبیه‌سازی نیست',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'فضا قابل حذف نیست',
        'API.TIMEZONE_NOT_FOUND': 'منطقه زمانی یافت نشد',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'توکن در هدرها یافت نشد، لطفاً وارد شوید',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'حساب کاربری قفل شده است',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'حساب کاربری منقضی شده است',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'حساب کاربری قفل نیست',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'نام کاربری قبلاً استفاده شده است',
        'API.USER_NOT_FOUND': 'کاربر یافت نشد',
        'API.USER_PASSWORD_HAS_EXPIRED': 'رمز عبور کاربر منقضی شده است',
        'API.USER_PRIVILEGE_NOT_FOUND': 'دسترسی کاربر یافت نشد',
        'API.USER_SESSION_NOT_FOUND': 'نشست کاربر یافت نشد',
        'API.USER_SESSION_TIMEOUT': 'نشست کاربر منقضی شده است',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID کاربر در هدرها یافت نشد، لطفاً وارد شوید',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'نام کنتور مجازی قبلاً استفاده شده است',
        'API.VIRTUAL_METER_NOT_FOUND': 'کنتور مجازی یافت نشد',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'کنتور مجازی متغیر یافت نشد',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'نقطه داده مجازی باید مقدار آنالوگ باشد',
        'API.WEB_MESSAGE_NOT_FOUND': 'پیام وب یافت نشد',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'پیام وی‌چت یافت نشد',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'نام مزرعه بادی قبلاً استفاده شده است',
        'API.WIND_FARM_NOT_FOUND': 'مزرعه بادی یافت نشد',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'نام تقویم کاری قبلاً استفاده شده است',
        'API.WORKING_CALENDAR_NOT_FOUND': 'تقویم کاری یافت نشد',

        MasterMeter: 'جدول اصلی',
        SubMeter: 'جدول فرعی',
        'Power Quality': 'کیفیت برق',
        'About Power Quality': 'درباره کیفیت برق',
        Category: 'دسته‌بندی',
        Type: 'نوع',
        Limit: 'حد',
        'Normal Limit': 'حد عادی',
        'Severe Limit': 'حد شدید',
        Compliance: 'نرخ انطباق',
        'Worst Deviation': 'بدترین انحراف',
        'Worst Time': 'بدترین زمان',
        'Severe Exceed Count': 'تعداد تجاوزات شدید',
        'Worst Unbalance': 'بدترین عدم تعادل',
        Hz: 'هرتز',
        voltage: 'ولتاژ',
        current: 'جریان',
        frequency: 'فرکانس',
        voltage_deviation: 'انحراف ولتاژ',
        current_unbalance: 'عدم تعادل جریان',
        voltage_unbalance: 'عدم تعادل ولتاژ',
        mean_deviation_pct: 'میانگین انحراف (%)',
        p95_abs_deviation_pct: 'انحراف مطلق P95 (%)',
        mean_abs_deviation_hz: 'میانگین انحراف مطلق (Hz)',
        frequency_deviation: 'انحراف فرکانس',
        p95_abs_deviation_hz: 'انحراف مطلق P95 (Hz)',
        mean_unbalance_pct: 'میانگین عدم تعادل (%)',
        p95_unbalance_pct: 'عدم تعادل P95 (%)',
        count: 'تعداد',
        min: 'حداقل',
        max: 'حداکثر',
        mean: 'میانگین',
        std: 'انحراف معیار',
        p5: 'P5',
        p95: 'P95'
    }
};
